import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSleepGlyphSecondary from './svgs/SleepGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var sleepGlyph = (props => useIcon(null, SvgSleepGlyphSecondary, props));

export { sleepGlyph as default };
